import { createRouter, createWebHistory } from "vue-router";
import EditViewProfile from "@/components/Account/pages/account/profiles";
import CPAgreementNotInsuranceOrDpay from "@/components/agreements/customized/NoInsuranceOrPayForm.vue";
import AccountCreationSuccess from "@/components/auth/AccountCreation/AccountCreationSuccess.vue";
import CareerAndSkillsApp from "@/components/CareerAndSkillsApp";
import CitiesLandingPage from "@/components/Cities";
import CityDetails from "@/components/Cities/CityDetails.vue";
import HousingProductPageView from "@/components/Configurator/Housing/HousingProductPageView.vue";
import CurriculumIntegrationApp from "@/components/CurriculumIntegrationApp";
import ApproveCourses from "@/components/CurriculumIntegrationApp/pages/ApproveCourses.vue";
import CurriculumIntegrationDashboard from "@/components/CurriculumIntegrationApp/pages/Dashboard";
import CurriculumIntegrationHome from "@/components/CurriculumIntegrationApp/pages/Home";
import CPCodeOfConduct from "@/components/codeOfConduct/CustomizedCodeOfConduct.vue";
import Results from "@/components/ExperiencePage/Algolia/AlgoliaResults";
import RootWrapper from "@/components/ExperiencePage/Algolia/AlgoliaRootWrapper.vue";
import ResumeV3 from "@/components/ExperiencePage/Application/Steps/ResumeApplication.vue";
import ApplicationExists from "@/components/ExperiencePage/Views/ApplicationExistsPage.vue";
import CourseProductPageView from "@/components/ExperiencePage/Views/CourseProductPageView.vue";
import InternshipProductPageView from "@/components/ExperiencePage/Views/InternshipProductPageView.vue";
import ProgramDetailsView from "@/components/ExperiencePage/Views/ProgramDetailsView.vue";
import FareFinderView from "@/components/FareFinder/FareFinderView";
import LayoutV3 from "@/components/forms/applicationSteps/StepsLayoutV3.vue";
import BadgesForm from "@/components/forms/BadgesInterests/BadgesPage.vue";
import EULA_Form from "@/components/forms/EULA/EULA_Form.vue";
import HousingQuestionnaireForm from "@/components/forms/HousingQuestionnaire/HousingQuestionnaireForm.vue";
import HSCodeOfConductForm from "@/components/forms/HSCodeOfConduct/HSCodeOfConductForm.vue";
import ParticipantAgreementIND from "@/components/forms/ParticipantAgreementIND/ParticipantAgreementForm.vue";
import TranscriptReleaseForm from "@/components/forms/TranscriptRelease/components/TranscriptReleaseForm";
import HomeApp from "@/components/HomeApp";
import HostInstitution from "@/components/HostInstitution";
import HostInstitutionDetails from "@/components/HostInstitution/HostInstitutionDetails.vue";
import InternshipForm from "@/components/InternshipLibrary/InternshipForm";
import LayoutLoader from "@/components/LayoutLoader.vue";
import LegacyMyApplications from "@/components/MyExperiences/LegacyMyApplications.vue";
import MyStudentsContainer from "@/components/MyStudents";
import MyStudentsSubmissionDetails from "@/components/MyStudents/Submissions/index.vue";
import { resolveOnboardingPageRedirect } from "@/components/MyStudents/utils";
import Profile from "@/components/Profile";
import ProgramManager from "@/components/program-manager";
import ProgramManagerCreateEdit from "@/components/program-manager/create-edit";
import CreateEditEvents from "@/components/program-manager/events/CreateEditEvents.vue";
import Housing from "@/components/program-manager/housing";
import CreateEditProgramSessions from "@/components/program-manager/sessions";
import ProgramManagerViewMore from "@/components/program-manager/view-more";
import RegistrationProcess from "@/components/RegistrationProcess/index.vue";
import RegistrationBridge from "@/components/RegistrationProcess/RegistrationBridge/index.vue";
import ResearchApp from "@/components/ResearchApp";
import StudentFulfillmentManager from "@/components/StudentFulfillment/components/MainPage";
import OrderDetail from "@/components/StudentFulfillment/components/OrderDetail";
import ViewReports from "@/components/StudentFulfillment/components/report/ViewReports";
import StudentManagement from "@/components/StudentManagement.vue";
import SettingsView from "@/components/settings/FormattingPage.vue";
import FailedReport from "@/components/VizLoader/FailedReport.vue";
import {
  checkPremiumAppAccess,
  checkTableauAppAccess,
  hasAiAdvisingChatbotEnabled,
  hasDiscountPricingPermission,
  hasDisplayAdminUIForStudentDiscountsEnabled,
  hasExperienceDetailsPageEnabled,
  hasMyExperiencePageEnabled,
  hasMyExperiencesConnectAiqEnabled,
  hasMyStudentsToDosEnabled,
  hasPriceOverrideApprovalsAccess,
  isTenantManager,
} from "@/composables/authorization.js";
import {
  redirectIfFeatureFlagNotEnabled,
  V3_rejectNavigation,
  V3_rejectNavigation_no_auth,
  V3_rejectNavigation_no_program_session,
} from "@/composables/VersionHelper.js";
import store from "@/store/index.js";
import MyStudents from "@/university/views/MyStudents";
import NotificationSettings from "@/university/views/NotificationSettings.vue";
import StudentDetail from "@/university/views/StudentDetail";
import AccountPage from "./components/Account/components/AccountPage.vue";
import AnonymousAdvising from "./components/AnonymousAdvising/index.vue";
import AcademicInformation from "./components/academicInformation/AcademicInformation.vue";
import ParticipantAgreement from "./components/agreements/participant-agreement";
import EmployeeRegister from "./components/auth/EmployeeRegister";
import OktaRedirect from "./components/auth/OktaRedirect.vue";
import CodeOfConduct from "./components/codeOfConduct/CodeOfConduct.vue";
import EnrollmentLanding from "./components/EnrollmentLanding.vue";
import errorPage from "./components/errorPage.vue";
import FinancialAidVerification from "./components/financialAid/FinancialAidVerification.vue";
import CoursePage from "./components/forms/CourseSelection/CoursePage.vue";
import GroupVisaForm from "./components/forms/GroupVisaInformation/GroupVisaForm.vue";
import HeadShotForm from "./components/forms/HeadShot/HeadshotForm.vue";
import HousingForm from "./components/forms/Housing/HousingForm.vue";
import NoInsuranceDirectPayForm from "./components/forms/ParticipantAgreement/NoInsuranceDirectPayForm.vue";
import ParticipantAgreementID from "./components/forms/ParticipantAgreementID/ParticipantAgreementForm.vue";
import PassportWrapper from "./components/forms/Passport/PassportWrapper.vue";
import PolimodaRegulationsPolicy from "./components/forms/PolimodaRegulationsPolicy/PolimodaRegulationsPolicy.vue";
import SupplementalForm from "./components/forms/Supplemental/SupplementalForm.vue";
import VisaAndPermitForm from "./components/forms/VisaAndPermit/VisaAndPermitForm.vue";
import VisaAppointment from "./components/forms/VisaAppointment/VisaAppointmentForm.vue";
import HealthWellnessFormWrapper from "./components/HealthWellness/HealthWellnessFormWrapper.vue";
import Impersonation from "./components/Impersonation/Students";
import LandingPage from "./components/LandingPage";
import MyApplications from "./components/MyApplications.vue";
import MyExperienceDetails from "./components/MyExperiences/MyExperienceDetails.vue";
import MyExperiences from "./components/MyExperiences/MyExperiences.vue";
import NetworkOfSupportPage from "./components/NetworkOfSupport/NetworkOfSupportPage.vue";
import SingleFormLoader from "./components/Onboarding/SingleFormLoader";
import CustomPricingPage from "./components/OperationsApp/pages/operations/custom-pricing/index.vue";
import OperationsDashboard from "./components/OperationsApp/pages/operations/dashboard/index.vue";
import Operations from "./components/OperationsApp/pages/operations/index.vue";
import PriceOverridesApprovals from "./components/OperationsApp/pages/operations/price-override-requests/index.vue";
import PaymentView from "./components/PaymentView";
import ParsonsParisAgreement from "./components/parsonsParisAgreement/ParsonsParisAgreement.vue";
import ProgramManagerWrapper from "./components/program-manager/program-manager-wrapper.vue";
import SignIn from "./components/SignIn.vue";
import TravelPlans from "./components/travels/travel-plans/travel-plans.vue";
import {
  CONSTANT_KEYS,
  CURRICULUM_INTEGRATION_ROUTES,
  FEATURES,
  PERMISSIONS,
  PROGRAM_MANAGER_V2_ROUTES,
} from "./constants";
import Page404 from "./university/views/404Page.vue";

export const routes = [
  {
    path: "/",
    component: RootWrapper,
    name: "home",
    props: true,
    meta: {
      title: "",
      ui: { layout: "experience" },
    },
  },
  {
    path: "/fare-finder",
    component: FareFinderView,
    name: "fare-finder",
    meta: {
      title: "Fare Finder",
      loginRequired: true,
      permissions: ["participants"],
      ui: { layout: "experience-minimal" },
    },
  },
  {
    path: "/application-exists",
    component: ApplicationExists,
    name: "application-exists",
    meta: {
      title: "Application Exists",
    },
  },
  {
    path: "/account",
    component: AccountPage,
    name: "account",
    meta: {
      title: "Account Settings",
    },
    children: [
      {
        path: "profiles/:profileId",
        name: "edit-profile",
        component: EditViewProfile,
        meta: {
          title: "View/Edit Profile Detail",
          description: "View/Edit Detail",
          loginRequired: true,
        },
      },
      {
        path: "settings/host-institutions",
        name: "host-institutions",
        component: HostInstitution,
      },
      {
        path: "settings/host-institutions/:hostInstitutionId",
        name: "host-institution-edit",
        component: HostInstitutionDetails,
        props: true,
        meta: {
          title: "Host Institution",
          breadcrumb: [
            { title: "Host Institutions", parent: "host-institutions" },
            {
              title: "Edit Host Institution Details",
              parent: "host-institution-edit",
            },
          ],
          subcategory: "host-institutions",
          permissions: [PERMISSIONS.ITEMS_WRITE],
        },
      },
      {
        path: "settings/cities",
        name: "cities",
        component: CitiesLandingPage,
      },
      {
        path: "settings/cities/:cityId",
        name: "city-edit",
        component: CityDetails,
        props: true,
        meta: {
          title: "Cities",
          breadcrumb: [
            { title: "Cities", parent: "cities" },
            {
              title: "Edit City Details",
              parent: "city-edit",
            },
          ],
          subcategory: "cities",
          permissions: [PERMISSIONS.ITEMS_WRITE],
        },
      },
      {
        path: "settings/brand",
        name: "brand",
        component: SettingsView,
        permissions: [PERMISSIONS.TENANT_MANAGER],
      },
      {
        path: "settings/user-management",
        name: "user-management",
        component: Profile,
        meta: {
          permissions: [PERMISSIONS.USERS_WRITE],
        },
      },
      {
        path: "settings/profiles/:participantId",
        name: "user-management-profile",
        component: EditViewProfile,
        meta: {
          permissions: [PERMISSIONS.USERS_WRITE],
        },
      },
      {
        path: "about-you/",
        name: "about-you",
        component: EditViewProfile,
        meta: {
          loginRequired: true,
        },
      },
    ],
  },
  {
    path: "/settings",
    component: SettingsView,
    name: "settings",
    meta: {
      title: "Settings",
      permissions: [PERMISSIONS.TENANT_MANAGER],
    },
  },
  {
    path: "/landing-page",
    component: LandingPage,
    name: "landing-page",
    meta: {
      title: "API Connect",
    },
  },
  {
    path: "/EULA",
    component: EULA_Form,
    name: "EULA",
    meta: {
      title: "End User License Agreement",
    },
  },
  {
    path: "/quiz",
    component: "",
    name: "Quiz",
    meta: {
      title: "Quiz",
    },
  },
  {
    path: "/my-experiences",
    component: MyExperiences,
    name: "experiences",
    meta: {
      title: "My Experiences",
      loginRequired: true,
    },
    beforeEnter: (to) => {
      if (hasMyExperiencesConnectAiqEnabled.value) {
        // /experiences is a different app that nginx serves, so this has to leave the SPA. The
        // query comes off `to` because window.location still holds the page being left.
        window.location.replace(`/experiences${to.fullPath.slice(to.path.length)}`);
        return false;
      }
      return hasMyExperiencePageEnabled.value ? true : { name: "applications" };
    },
  },
  {
    path: "/experience-detail/:applicationId",
    component: MyExperienceDetails,
    name: "experience-detail",
    meta: {
      title: "My Experience Details",
      loginRequired: true,
    },
    beforeEnter: (to) => {
      if (hasExperienceDetailsPageEnabled.value) {
        return true;
      }
      return {
        name: "applications/landing",
        params: { applicationId: to.params?.applicationId },
      };
    },
  },
  {
    path: "/legacy-application/:applicationId",
    component: LegacyMyApplications,
    name: "legacy-application",
  },
  {
    path: "/applications",
    component: MyApplications,
    name: "applications",
    meta: {
      title: "My Applications",
    },
    beforeEnter: () => {
      return !hasMyExperiencePageEnabled.value ? true : { name: "experiences" };
    },
  },
  {
    path: "/:applicationId/make-payment",
    component: PaymentView,
    name: "payment",
    meta: {
      title: "Payment",
    },
  },
  {
    path: "/error-page",
    component: errorPage,
    name: "error-page",
    meta: {
      title: "Error",
      ui: { layout: "bare" },
    },
    props: true,
  },
  {
    path: "/program/:programSessionId?",
    component: () => {
      if (CONSTANT_KEYS.UI_VERSION === "v2") {
        return import("./components/forms/customProgram/CustomProgramLandingPage");
      } else {
        return errorPage;
      }
    },
    name: "customProgram",
    meta: {
      title: "New custom program",
    },
  },
  {
    path: "/application-create-account/:sessionId",
    component: LayoutV3,
    name: "new-account-creation",
    meta: {
      title: "Create an account",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation_no_auth, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-about-you/:applicationId",
    component: LayoutV3,
    name: "application-about-you",
    meta: {
      title: "About You",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-learner-info/:applicationId",
    component: LayoutV3,
    name: "application-learner-info",
    meta: {
      title: "Learner Information",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-review/:applicationId",
    component: LayoutV3,
    name: "application-review",
    meta: {
      title: "Review application",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-group-visa/:applicationId",
    component: LayoutV3,
    name: "application-group-visa",
    meta: {
      title: "Group Visa Service",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-checkout/:applicationId",
    component: LayoutV3,
    name: "application-checkout",
    meta: {
      title: "Checkout",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-next-steps/:applicationId",
    component: LayoutV3,
    name: "application-next-steps",
    meta: {
      title: "Next steps",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation, V3_rejectNavigation_no_program_session],
  },
  {
    path: "/application-resume/:applicationId",
    component: ResumeV3,
    name: "application-resume",
    meta: {
      title: "Resuming application",
      addBackBreadcrumb: true,
      breadcrumb: [],
    },
    beforeEnter: [V3_rejectNavigation],
  },
  {
    path: "/applications/new",
    redirect: "/applications/new/program-selection",
    meta: {
      title: "Program selection",
    },
  },
  {
    path: "/curriculum-integration",
    name: CURRICULUM_INTEGRATION_ROUTES.APP,
    component: CurriculumIntegrationApp,
    redirect: { name: CURRICULUM_INTEGRATION_ROUTES.HOME },
    meta: {
      title: "Curriculum Integration",
      showEntityChanger: true,
    },
    beforeEnter: () => {
      return checkPremiumAppAccess() ? true : { name: "landing-page" };
    },
    children: [
      {
        path: "",
        component: CurriculumIntegrationHome,
        name: CURRICULUM_INTEGRATION_ROUTES.HOME,
        meta: {
          title: "Curriculum Integration Home",
        },
      },
      {
        path: "dashboard",
        component: CurriculumIntegrationDashboard,
        name: CURRICULUM_INTEGRATION_ROUTES.DASHBOARD,
        meta: {
          title: "Curriculum Integration Dashboard",
        },
      },
    ],
  },
  {
    path: "/curriculum-integration/approve-courses",
    name: CURRICULUM_INTEGRATION_ROUTES.APPROVE_COURSES,
    component: ApproveCourses,
    meta: {
      title: "Approve Courses",
      showEntityChanger: true,
    },
    beforeEnter: () => {
      return checkPremiumAppAccess() ? true : { name: "landing-page" };
    },
  },
  {
    path: "/research",
    name: "research-app",
    component: ResearchApp,
    meta: {
      title: "Research",
    },
    beforeEnter: () => {
      return checkTableauAppAccess(PERMISSIONS.ENABLE_RESEARCH_APP) ? true : { name: "landing-page" };
    },
  },
  {
    path: "/home",
    name: "home-app",
    component: HomeApp,
    meta: {
      title: "Home",
      showEntityChanger: true,
    },
    beforeEnter: () => {
      return checkTableauAppAccess(PERMISSIONS.ENABLE_HOME_APP) ? true : { name: "landing-page" };
    },
  },
  {
    path: "/qa-bad-report",
    name: "qa-bad-report",
    component: FailedReport,
    meta: {
      title: "Tableau failed Report",
    },
    beforeEnter: () => {
      return checkTableauAppAccess(PERMISSIONS.ENABLE_CAREER_AND_SKILLS_APP) ? true : { name: "landing-page" };
    },
  },
  {
    path: "/career-and-skills",
    name: "career-and-skills-app",
    component: CareerAndSkillsApp,
    meta: {
      title: "Career And Skills",
    },
    beforeEnter: () => {
      return checkTableauAppAccess(PERMISSIONS.ENABLE_CAREER_AND_SKILLS_APP) ? true : { name: "landing-page" };
    },
  },
  {
    path: "/applications/new/:slug",
    component: LayoutLoader,
    name: "applications/new",
    props: true,
    meta: {
      title: "New application",
    },
  },
  {
    path: "/:applicationId/university-approval-form",
    redirect: "/:applicationId/university-approval-request",
    meta: {
      loginRequired: true,
    },
  },
  {
    path: "/applications/:applicationId/:slug?",
    component: LayoutLoader,
    name: "applications/resume",
    props: true,
    meta: {
      title: "Resume Application",
    },
  },
  {
    path: "/enrollment/:applicationId",
    component: EnrollmentLanding,
    name: "applications/landing",
    props: true,
    meta: {
      title: "Enrollment",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/travel-plans",
    component: TravelPlans,
    name: "enrollment/travel-plans",
    props: true,
    meta: {
      title: "Travel Plans",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/health-wellness",
    component: HealthWellnessFormWrapper,
    name: "enrollment/health-wellness",
    props: true,
    meta: {
      title: "Health & Wellness",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/participant-agreement",
    component: ParticipantAgreement,
    name: "enrollment/participant-agreement",
    meta: {
      title: "Participant Agreement",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/financial-aid-verification",
    component: FinancialAidVerification,
    name: "enrollment/financial-aid-verification",
    props: true,
    meta: {
      title: "Financial aid verification",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/code-of-conduct",
    component: CodeOfConduct,
    name: "enrollment/code-of-conduct",
    props: true,
    meta: {
      title: "Code of Conduct",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/network-of-support",
    component: NetworkOfSupportPage,
    name: "enrollment/network-of-support",
    props: true,
    meta: {
      title: "Network of Support",
      loginRequired: true,
    },
  },
  {
    path: "/sign-in/:component?",
    component: SignIn,
    name: "sign-in",
    props: true,
    meta: {
      title: "Sign in",
      ui: { layout: "auth" },
    },
  },
  {
    path: "/sign-in/change-password/:token",
    component: SignIn,
    name: "change-password",
    props: true,
    meta: {
      title: "Sign in",
      ui: { layout: "auth" },
    },
  },
  {
    path: "/login/okta",
    component: OktaRedirect,
    name: "login-okta-handoff",
    meta: {
      title: "",
      ui: { layout: "bare" },
    },
  },
  {
    path: "/employee-register",
    component: EmployeeRegister,
    name: "employee-register",
    meta: {
      title: "Register employee account",
    },
    props: true,
  },
  {
    path: "/create-account",
    component: SignIn,
    name: "create-account",
    meta: {
      title: "Create account",
      ui: { layout: "bare" },
    },
  },
  {
    path: "/create-account-success",
    component: AccountCreationSuccess,
    name: "create-account-success",
    meta: {
      title: "Create Account Success",
      ui: { layout: "auth" },
    },
  },
  {
    path: "/enrollment/:applicationId/academic-information",
    component: AcademicInformation,
    name: "enrollment/academic-information",
    props: true,
    meta: {
      title: "Academic Information",
      loginRequired: true,
    },
  },
  {
    path: "/enrollment/:applicationId/parsons-paris-agreement",
    component: ParsonsParisAgreement,
    name: "enrollment/parsons-paris-agreement",
    props: true,
    meta: {
      title: "Parsons Paris Agreement",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/polimoda-student-regulation-policy",
    component: PolimodaRegulationsPolicy,
    name: "polimoda-student-regulation-policy",
    props: true,
    meta: {
      title: "Polimoda Student Regulation Policy",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/global-course-selection",
    component: CoursePage,
    name: "global-course-form",
    props: true,
    meta: {
      title: "Global Course Form",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/passport",
    component: PassportWrapper,
    name: "passport",
    props: true,
    meta: {
      title: "Passport",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/housing",
    component: HousingForm,
    name: "housing",
    props: true,
    meta: {
      title: "Housing",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/group-visa-information",
    component: GroupVisaForm,
    name: "group-visa-information",
    props: true,
    meta: {
      title: "Group Visa Information",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/visa-appointment-details",
    component: VisaAppointment,
    name: "visa-appointment-details",
    props: true,
    meta: {
      title: "Visa Appointment Details",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/visa-permit",
    component: VisaAndPermitForm,
    name: "visa-permit",
    props: true,
    meta: {
      title: "Visa Permit",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/headshot",
    component: HeadShotForm,
    name: "headshot",
    props: true,
    meta: {
      title: "Headshot",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/digital-badges",
    component: BadgesForm,
    name: "digitalBadges",
    props: true,
    meta: {
      title: "Digital Badges",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/customized-code-of-conduct",
    component: CPCodeOfConduct,
    name: "cpcodeofconduct",
    props: true,
    meta: {
      title: "Customized Code of Conduct",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/supplemental-form",
    component: SupplementalForm,
    name: "supplemental-form",
    props: true,
    meta: {
      title: "Supplemental Form",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/custom-participant-agreement-i-nd",
    component: ParticipantAgreementIND,
    name: "custom-participant-agreement-i-nd",
    props: true,
    meta: {
      title: "Participant Agreement",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/custom-participant-agreement-i-d",
    component: ParticipantAgreementID,
    name: "custom-participant-agreement-i-d",
    props: true,
    meta: {
      title: "Participant Agreement",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/custom-participant-agreement-ni-d",
    component: NoInsuranceDirectPayForm,
    name: "custom-participant-agreement-ni-d",
    props: true,
    meta: {
      title: "Participant Agreement",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/custom-participant-agreement-ni-nd",
    component: CPAgreementNotInsuranceOrDpay,
    name: "noinsuranceorpayagreement",
    props: true,
    meta: {
      title: "Participant Agreement",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/hs-code-of-conduct",
    component: HSCodeOfConductForm,
    name: "hs-code-of-conduct",
    props: true,
    meta: {
      title: "HS Code of Conduct",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/housing-questionnaire",
    component: HousingQuestionnaireForm,
    name: "housing-questionnaire",
    props: true,
    meta: {
      title: "Housing questionnaire",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/transcript-release-form",
    component: TranscriptReleaseForm,
    name: "transcript-release-form",
    props: true,
    meta: {
      title: "Transcript Release Form",
      loginRequired: true,
    },
  },
  {
    path: "/:applicationId/:form",
    component: SingleFormLoader,
    name: "form-loader",
    props: true,
    meta: {
      loginRequired: true,
    },
  },
  {
    path: "/students",
    component: Impersonation,
    name: "impersonation",
    props: true,
    meta: {
      loginRequired: true,
      permissions: ["api-employee-student-view"],
      ui: { layout: "portal" },
    },
  },
  {
    path: "/student-management",
    redirect: { name: "student-management" },
  },
  {
    path: "/my-students/anonymous-advising",
    name: "my-students-app-anonymous-advising",
    component: AnonymousAdvising,
    meta: {
      title: "Anonymous Advising",
      showSideMenu: false,
      showTopMenu: true,
    },
    beforeEnter: () => (hasAiAdvisingChatbotEnabled.value && isTenantManager() ? true : { name: "landing-page" }),
  },
  {
    path: "/my-students/:page?/:oktaId?",
    component: MyStudentsContainer,
    name: "student-management",
    props: true,
    meta: {
      title: "Student Management",
      loginRequired: true,
      permissions: ["student-management"],
      showEntityChanger: true,
    },
    beforeEnter: (to) => resolveOnboardingPageRedirect(to, hasMyStudentsToDosEnabled.value),
  },
  {
    path: "/my-students-retired",
    component: MyStudents,
    name: "student-management-retired",
    props: true,
    meta: {
      title: "Retired Student Management",
      loginRequired: true,
      permissions: ["student-management"],
    },
    beforeEnter: () => redirectIfFeatureFlagNotEnabled(FEATURES.myStudentsRetired),
  },
  {
    path: "/my-students/benchmarking",
    name: "my-students-app-benchmarking",
    component: MyStudentsContainer,
    meta: {
      title: "Student Reporting - Benchmarking",
      loginRequired: true,
      showEntityChanger: true,
    },
  },
  {
    path: "/student-management-retired",
    component: StudentManagement,
    name: "student-management-view-retired",
    props: true,
    meta: {
      title: "Retired Student Management",
      loginRequired: true,
      permissions: ["student-management"],
      ui: { layout: "portal-minimal" },
    },
    beforeEnter: () => redirectIfFeatureFlagNotEnabled(FEATURES.myStudentsRetired),
  },
  {
    path: "/student-detail/:id/:tab",
    name: "Student Details",
    component: StudentDetail,
    props: true,
  },
  {
    path: "/notification-settings",
    name: "notification-settings",
    component: NotificationSettings,
    meta: {
      loginRequired: true,
      ui: { layout: "portal" },
    },
  },
  {
    path: "/program-manager",
    name: "program-manager-root",
    meta: {
      showEntityChanger: true,
    },
    component: Operations,
    redirect: () => {
      const userPermissions = store?.getters?.getPermissions ?? [];
      const prgmsPermissions = [PERMISSIONS.PRGMS_READ, PERMISSIONS.PRGMS_READ_LITE];
      const found = userPermissions.some((r) => prgmsPermissions.includes(r));
      if (found) {
        return { name: "program-manager-sessions" };
      }
      return { name: "program-manager-housing" };
    },
    children: [
      {
        path: "programs",
        name: "program-manager-programs",
        component: ProgramManager,
        meta: {
          title: "Programs",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "programs",
          permissions: [PERMISSIONS.PRGMS_READ, PERMISSIONS.PRGMS_READ_LITE],
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "sessions",
        name: PROGRAM_MANAGER_V2_ROUTES.PROGRAM_SESSIONS,
        component: ProgramManagerWrapper,
        meta: {
          title: "Program Sessions",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "sessions",
          permissions: [PERMISSIONS.PRGMS_READ, PERMISSIONS.PRGMS_READ_LITE],
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "housing",
        name: "program-manager-housing",
        component: ProgramManager,
        meta: {
          title: "Housing",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "housing",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "classes",
        name: "program-manager-classes",
        component: ProgramManager,
        meta: {
          title: "Classes",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "classes",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "housing/:itemId",
        name: "housing-edit",
        component: Housing,
        meta: {
          title: "Housing",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "housing",
          permissions: [PERMISSIONS.ITEMS_READ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "programs/view-more",
        name: PROGRAM_MANAGER_V2_ROUTES.PROGRAMS,
        component: ProgramManagerViewMore,
        meta: {
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-programs" }],
          subcategory: "programs",
          permissions: [PERMISSIONS.PRGMS_READ, PERMISSIONS.PRGMS_READ_LITE],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "sessions/view-more",
        name: "sessions-view-more",
        component: ProgramManagerViewMore,
        meta: {
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-programs" }],
          subcategory: "sessions",
          permissions: [
            PERMISSIONS.ITEMS_READ,
            PERMISSIONS.ITEMS_READ_LITE,
            PERMISSIONS.PRGMS_READ,
            PERMISSIONS.PRGMS_READ_LITE,
          ],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "programs/create-new",
        name: "programs-create",
        component: ProgramManagerCreateEdit,
        meta: {
          title: "Program Manager",
          subcategory: "programs",
          permissions: [PERMISSIONS.PRGMS_WRITE],
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Programs", parent: "program-manager-programs" },
            { title: "Create Program Page", parent: "programs-create" },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "programs/:itemId",
        name: "programs-edit",
        component: ProgramManagerCreateEdit,
        props: true,
        meta: {
          title: "Program Manager",
          subcategory: "programs",
          permissions: [PERMISSIONS.PRGMS_WRITE, PERMISSIONS.PRGMS_PUB],
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Programs", parent: "program-manager-programs" },
            { title: "Edit Program Page", parent: "programs-edit" },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "housing/view-more",
        name: PROGRAM_MANAGER_V2_ROUTES.HOUSING,
        component: ProgramManagerViewMore,
        meta: {
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "housing",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "housing/view-more/:housingType?",
        name: "housing-create",
        component: ProgramManagerViewMore,
        props: {
          defaultOpen: true,
        },
        meta: {
          title: "Create Housing",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "housing",
          permissions: [PERMISSIONS.ITEMS_WRITE],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "classes/view-more",
        name: PROGRAM_MANAGER_V2_ROUTES.CLASSES,
        component: ProgramManagerViewMore,
        meta: {
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "classes",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "internships",
        name: "program-manager-internships",
        component: ProgramManager,
        meta: {
          title: "Internships",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "internships",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "internships/view-more",
        name: PROGRAM_MANAGER_V2_ROUTES.INTERNSHIPS,
        component: ProgramManagerViewMore,
        meta: {
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "internships",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "internships/create-new",
        name: "create-internship",
        component: InternshipForm,
        meta: {
          title: "Internship Library",
          permissions: [PERMISSIONS.ITEMS_WRITE],
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Internships", parent: "program-manager-internships" },
            { title: "Create Internship", parent: "create-internship" },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "internships/item-:itemId",
        name: "internship-item",
        component: InternshipForm,
        meta: {
          title: "Internship Library",
          subcategory: "internships",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Internships", parent: "program-manager-internships" },
            {
              title: "Internship Detail",
              parent: "internship-item",
            },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "events",
        name: "program-manager-events",
        component: ProgramManager,
        meta: {
          title: "Excursions + Events",
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "events",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "events/view-more",
        name: PROGRAM_MANAGER_V2_ROUTES.EXCURSIONS_EVENTS,
        component: ProgramManagerViewMore,
        meta: {
          breadcrumb: [{ title: "Program Manager", parent: "program-manager-root" }],
          subcategory: "events",
          permissions: [PERMISSIONS.ITEMS_READ, PERMISSIONS.ITEMS_READ_LITE],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "events/create-new",
        name: "create-event",
        component: CreateEditEvents,
        meta: {
          title: "Excursions + Events",
          permissions: [PERMISSIONS.ITEMS_WRITE],
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Excursions + Events", parent: "program-manager-events" },
            { title: "Create Excursion + Event", parent: "create-event" },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "events/:itemId",
        name: "edit-event",
        component: CreateEditEvents,
        meta: {
          title: "Excursions + Events",
          permissions: [PERMISSIONS.ITEMS_WRITE],
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Excursions + Events", parent: "program-manager-events" },
            { title: "Edit Excursion + Event", parent: "edit-event" },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "sessions/:programSessionId",
        name: PROGRAM_MANAGER_V2_ROUTES.EDIT_SESSIONS,
        component: CreateEditProgramSessions,
        props: true,
        meta: {
          title: "Program Session",
          permissions: [PERMISSIONS.PRGMS_WRITE],
          subcategory: "sessions",
          breadcrumb: [
            { title: "Program Manager", parent: "program-manager-root" },
            { title: "Program Session", parent: "program-manager-sessions" },
            {
              title: "Create Core Program Session",
              parent: PROGRAM_MANAGER_V2_ROUTES.EDIT_SESSIONS,
            },
          ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "operations/",
        name: "student-fulfillment",
        component: StudentFulfillmentManager,
        meta: {
          title: "Student Fulfillment",
          permissions: [PERMISSIONS.ORDERS_READ, PERMISSIONS.API_EMPLOYEE_STUDENT_VIEW],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "operations/order-details/:orderId",
        name: "order-detail",
        component: OrderDetail,
        meta: {
          title: "Order Details",
          breadcrumb: [
            { title: "Student Fulfillment", parent: "student-fulfillment" },
            { title: "View Order Details", parent: "order-detail" },
          ],
          permissions: [PERMISSIONS.ORDERS_READ],
          showSideMenu: false,
          showTopMenu: false,
        },
      },
      {
        path: "operations/reports",
        name: "fulfillment-reports",
        component: ViewReports,
        meta: {
          title: "View Reports",
          breadcrumb: [
            { title: "Student Fulfillment", parent: "student-fulfillment" },
            { title: "View Reports", parent: "fulfillment-reports" },
          ],
          permissions: [PERMISSIONS.ORDERS_READ, PERMISSIONS.TABLEAU_VIEWER],
          showSideMenu: false,
          showTopMenu: true,
        },
      },
      {
        path: "dashboard",
        name: "operations-dashboard",
        component: OperationsDashboard,
        meta: {
          showSideMenu: true,
          showTopMenu: false,
        },
      },
      {
        path: "operations/price-override-approvals",
        name: "price-override-approvals",
        component: PriceOverridesApprovals,
        meta: {
          title: "Price Override Requests",
          showSideMenu: false,
          showTopMenu: true,
        },
        beforeEnter: () => {
          return hasPriceOverrideApprovalsAccess.value ? true : { name: "landing-page" };
        },
      },
      {
        path: "operations/custom-pricing",
        name: "custom-pricing",
        component: CustomPricingPage,
        meta: {
          title: "Custom Pricing",
          showSideMenu: true,
          showTopMenu: false,
        },
        beforeEnter: () => {
          return hasDisplayAdminUIForStudentDiscountsEnabled.value && hasDiscountPricingPermission.value
            ? true
            : { name: "landing-page" };
        },
      },
    ],
  },
  {
    path: "/personalize/:programPageId",
    component: RegistrationBridge,
    name: "personalize",
    children: [
      {
        path: "new/:slug?",
        component: RegistrationBridge,
        name: "configurator-new",
      },
      {
        path: ":orderId/:slug?",
        component: RegistrationBridge,
        name: "configurator",
      },
    ],
    meta: {
      title: "Personalize & Apply",
      addBackBreadcrumb: true,
      breadcrumb: [],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/results",
    name: "results",
    redirect: "/results/programs",
    component: Results,
    children: [
      {
        path: "programs",
        component: Results,
        name: "programs-results-view",
      },
      {
        path: "internship-postings",
        component: Results,
        name: "internship-postings-results-views",
      },
      {
        path: "courses",
        component: Results,
        name: "courses-results-view",
      },
    ],
    meta: {
      title: "Experience Results",
      breadcrumb: [
        { title: "Home", parent: "home" },
        { title: "Results", parent: "results" },
      ],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/results/internships",
    component: InternshipProductPageView,
    name: "internship-product-page-view",
    meta: {
      title: "Internship Posting",
      breadcrumb: [
        { title: "Home", parent: "home" },
        { title: "Results", parent: "internship-postings-results-views" },
        {
          title: "Internships Postings",
          parent: "internship-product-page-view",
        },
      ],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/results/housing",
    component: HousingProductPageView,
    name: "housing-product-page-view",
    meta: {
      breadcrumb: [
        { title: "Home", parent: "home" },
        { title: "Browse All Programs", parent: "results" },
        { title: "Program Detail", parent: "program-detail-view" },
        { title: "Personalize & Apply", parent: "personalize" },
        {
          title: "Housing Detail",
          parent: "housing-product-page-view",
        },
      ],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/my-students/review/:applicationId/:todoId",
    component: MyStudentsSubmissionDetails,
    name: "my-students-review",
    meta: {
      loginRequired: true,
      breadcrumb: [{ title: "My Students", parent: "student-management" }],
    },
    props: true,
  },
  {
    path: "/results/courses/:courseId",
    component: CourseProductPageView,
    name: "course-product-page-view",
    meta: {
      title: "Course Page",
      breadcrumb: [
        { title: "Home", parent: "home" },
        { title: "Browse All Programs", parent: "results" },
        {
          title: "Course Detail",
          parent: "course-product-page-view",
        },
      ],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/program-page/:programPageId",
    component: ProgramDetailsView,
    name: "program-detail-view",
    meta: {
      title: "Program Detail",
      breadcrumb: [
        { title: "Home", parent: "home" },
        { title: "Browse All Programs", parent: "results" },
        { title: "Program Detail", parent: "program-detail-view" },
      ],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/registration",
    children: [
      {
        path: "new/:programPageId/:sessionId/:stage?/:step?/",
        component: RegistrationProcess,
        name: "new-application",
      },
      {
        path: ":applicationId/:stage?/:step?",
        component: RegistrationProcess,
        name: "modify-application",
      },
    ],
    meta: {
      addBackBreadcrumb: true,
      breadcrumb: [],
      ui: { layout: "experience" },
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: Page404,
    meta: {
      ui: { layout: "bare" },
    },
  },
];

export const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // Exists when Browser's back/forward pressed
    if (savedPosition) {
      return savedPosition;
      // For anchors
    } else if (to.hash) {
      return { el: to.hash };
      // By changing queries we are still in the same component, so "from.path" === "to.path" (new query changes just "to.fullPath", but not "to.path").
    } else if (from.path === to.path) {
      return {};
    }
    // Scroll to top
    window.scrollTo(0, 0);
    return { x: 0, y: 0 };
  },
});

export default routes;
